import { baseApi } from './baseApi';

export const purchaseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseOrders: builder.query({
      query: (params) => ({
        url: '/purchase/orders',
        params,
      }),
      providesTags: ['Purchase'],
    }),
    getPurchaseOrder: builder.query({
      query: (id) => `/purchase/orders/${id}`,
      providesTags: (result, error, id) => [{ type: 'Purchase', id }],
    }),
    getPurchaseReturns: builder.query({
      query: (params) => ({
        url: '/purchase/returns',
        params,
      }),
      providesTags: ['PurchaseReturn'],
    }),
    getPurchaseReturn: builder.query({
      query: (id) => `/purchase/returns/${id}`,
      providesTags: (result, error, id) => [{ type: 'PurchaseReturn', id }],
    }),
    createPurchaseReturn: builder.mutation({
      query: (data) => ({
        url: '/purchase/returns',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PurchaseReturn'],
    }),
    createPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: '/purchase/orders',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Purchase'],
    }),
    updatePurchaseOrderStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/purchase/orders/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => ['Purchase', { type: 'Purchase', id }],
    }),
    deletePurchaseOrder: builder.mutation({
      query: (id) => ({
        url: `/purchase/orders/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => ['Purchase', { type: 'Purchase', id }],
    }),
    getPaymentAccounts: builder.query({
      query: () => '/purchase/payment-accounts',
      providesTags: ['Purchase'],
    }),
    getSuppliers: builder.query({
      query: (params) => ({
        url: '/purchase/suppliers',
        params,
      }),
      providesTags: ['Supplier'],
    }),
    getSupplier: builder.query({
      query: (id) => `/purchase/suppliers/${id}`,
      providesTags: (result, error, id) => [{ type: 'Supplier', id }],
    }),
    getSupplierHistory: builder.query({
      query: (id) => `/purchase/suppliers/${id}/history`,
      providesTags: (result, error, id) => [{ type: 'Supplier', id }],
    }),
    createSupplier: builder.mutation({
      query: (data) => ({
        url: '/purchase/suppliers',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Supplier'],
    }),
    updateSupplier: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/purchase/suppliers/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Supplier'],
    }),
    toggleSupplierStatus: builder.mutation({
      query: (id) => ({
        url: `/purchase/suppliers/${id}/status`,
        method: 'POST',
      }),
      invalidatesTags: ['Supplier'],
    }),
    createSupplierPayment: builder.mutation({
      query: ({ supplierId, ...data }) => ({
        url: `/purchase/suppliers/${supplierId}/payments`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Supplier', 'Purchase'],
    }),
  }),
});

export const {
  useGetPurchaseOrdersQuery,
  useGetPurchaseOrderQuery,
  useCreatePurchaseOrderMutation,
  useUpdatePurchaseOrderStatusMutation,
  useDeletePurchaseOrderMutation,
  useGetPurchaseReturnsQuery,
  useGetPurchaseReturnQuery,
  useCreatePurchaseReturnMutation,
  useGetPaymentAccountsQuery,
  useGetSuppliersQuery,
  useGetSupplierQuery,
  useGetSupplierHistoryQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useToggleSupplierStatusMutation,
  useCreateSupplierPaymentMutation,
} = purchaseApi;
